const start = () => {
  if (window.__ROCKY_APP_STARTED__) return;
  window.__ROCKY_APP_STARTED__ = true;
  require("./Application").startApplication();
};

if (window.__ROCKY_GSAP__) start();
else {
  // An already-open or cached older HTML page may not contain the inline runtime.
  const loadOpening = (attempt = 0) => {
    const script = document.createElement("script");
    script.src = `/static/opening.js?compat=20261026&attempt=${attempt}`;
    script.onload = start;
    script.onerror = () => {
      script.remove();
      if (attempt < 2) window.setTimeout(() => loadOpening(attempt + 1), 500 * (attempt + 1));
    };
    document.head.appendChild(script);
  };
  loadOpening();
}

